










































import {
    BaseView,
    Component,
    Advisor,
    SectionType,
    InjectComponent,
    VueComponent,
    Prop
} from "@zoovu/runner-browser-api";
import {isRecommendationBundles} from "./utils";

@Component
export default class ResultsSectionView extends BaseView {
    @InjectComponent("AdvisorSectionView")
    advisorSectionView!: VueComponent;

    @InjectComponent("AdviceView")
    adviceView!: VueComponent;

    @InjectComponent("AdviceBundleView")
    adviceBundleView!: VueComponent;

    @InjectComponent("BrandingView")
    brandingView!: VueComponent;

    @InjectComponent("PagesNavigationView")
    pagesNavigationView!: VueComponent;

    @InjectComponent("PageSelectorView")
    pageSelectorView!: VueComponent;

    @Prop({default: false})
    showTopProduct!: boolean;

    @Prop({default: false})
    showPageSelector!: boolean;

    @Prop()
    advisor!: Advisor;

    get SectionType(): typeof SectionType {
        return SectionType;
    }

    get rootElementClass(): string {
        return "results-section";
    }

    get isBundle(): boolean {
        return isRecommendationBundles(this.advisor.advice);
    }

    resetFilters() {
        this.advisor.resetFilters();
    }
}
